import FYILogo from '../../../../../assets/fyi.png';
import IntegrationCard from '../../../../../components/integration-card/IntegrationCard';

type FirmFYIIntegrationCardProps = {
    status: 'CONNECTED' | 'ISSUE' | 'DEFAULT';
    onConfigure: (id: string) => void;
};

function FirmFYIIntegrationCard({ status, onConfigure }: FirmFYIIntegrationCardProps): JSX.Element {
    return (
        <IntegrationCard
            id="fyi"
            title="FYI"
            description="Connect FYI to Cimplico Workpapers to streamline your file referencing process. The integration also provides for seamless onboarding of entities, groups, and users."
            status={status}
            logo={FYILogo}
            onConfigure={onConfigure}
        />
    );
}
export default FirmFYIIntegrationCard;
